// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"74":"About","177":"home","372":"Business","596":"404","952":"Address","997":"Message"}[chunkId] + "." + {"74":"3ef88357","177":"8b659e82","372":"2ec991df","596":"ab2899f1","952":"053f7134","997":"2030f4cf"}[chunkId] + ".css";
};